import { useGetBrandsQuery } from '../../../../../../../apis/apiLists';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { filterByBrandId } from '../../../../../../Calculations/calculationsSlice';
import RedistributionGenericSelectorFilter from './RedistributionGenericSelectorFilter';

const NO_BRAND = '- No brand specified -';

/**
 * Allows to select a brand to filter the redistribution table by.
 * <p>Brands are retrieved from the backend. When selected it sets the calculations.redistributionFilterBrandId in the Redux Store</p>
 * @constructor
 */
const BrandRedistributionFilter: React.FC = () => {
  const { data, isFetching, isError } = useGetBrandsQuery(undefined);
  const redistributionFilterBrandId = useSelector(
    state => state.calculations.redistributionFilterBrandId,
  );

  const sortedBrands = useMemo(() => {
    if (data) {
      const newData = [...data];
      newData.sort((left, right) => {
        if (left.name === NO_BRAND) {
          return 1;
        }

        if (right.name === NO_BRAND) {
          return -1;
        }

        return left.name.localeCompare(right.name);
      });
      return newData;
    }
  }, [data]);

  const selectorOptions = useMemo(() => {
    if (sortedBrands) {
      return sortedBrands.map(brand => ({
        id: brand.id,
        label: brand.name,
      }));
    } else {
      return [];
    }
  }, [sortedBrands]);

  if (!isError) {
    return (
      <RedistributionGenericSelectorFilter
        label="Brand"
        options={selectorOptions}
        value={redistributionFilterBrandId}
        dispatcher={filterByBrandId}
        loading={isFetching}
      />
    );
  }
};

export default BrandRedistributionFilter;
